import { ApplicationConfig, APP_INITIALIZER, provideBrowserGlobalErrorListeners, ErrorHandler } from '@angular/core';
import { provideRouter, RouteReuseStrategy, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { CustomRouteReuseStrategy } from './core/strategies/custom-route-reuse.strategy';
import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { TenantConfigService } from './core/config/tenant-config';
import { DocumentTypeService } from './core/services/document-type.service';
import { apiStateInterceptor } from './core/interceptors/api-state-interceptor';
import { csrfInterceptor } from './core/interceptors/csrf.interceptor';
import { GlobalErrorHandler } from './core/errors/global-error-handler';
import { errorInterceptor } from './core/interceptors/error.interceptor';
// 1. The Factory function to fetch domain settings before boot
export function initializeAppFactory(configService: TenantConfigService) {
  return () => configService.loadSettings();
}

// 2. The Factory function to fetch document types before boot
export function loadDocumentTypesFactory(documentTypeService: DocumentTypeService) {
  return () => documentTypeService.loadDocumentTypes();
}

export const appConfig: ApplicationConfig = {
  providers: [
    // --- YOUR EXISTING CONFIGURATION ---
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes, 
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' })
    ), 
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({
        includeHeaders: ['X-Tenant'] // Whitelist your custom header here
      })
    ), // Keep event replay!

    // --- THE NEW MULTI-TENANT CONFIGURATION ---
    provideHttpClient(
      withFetch(),
      withInterceptors([apiStateInterceptor, csrfInterceptor, errorInterceptor])
    ), // Required to make API calls
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [TenantConfigService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: loadDocumentTypesFactory,
      deps: [DocumentTypeService],
      multi: true
    },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
};